/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getDrafts.defs.js'
export * as $defs from './getDrafts.defs.js'
